module.exports = __webpack_public_path__ + "static/media/blackLocation.90ade368.svg";